export default "__VITE_ASSET__BIYorBNM__"